import PropTypes from 'prop-types';
import styles from './Section.module.css';
import React, { useState } from 'react';
import { Collapse } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Field from 'features/dynamicForm/components/Field/Field';
import { sectionType } from 'features/dynamicForm/types';
import { useFormContext } from 'react-hook-form';

export default function Section({ section, dynamicFormId }) {
    const [collapsed, setCollapsed] = useState(section.collapsed ?? false);
    const {
        formState: { errors },
    } = useFormContext();

    const toggleCollapsed = () => setCollapsed((prev) => !prev);

    function generateKey(key) {
        return (dynamicFormId ?? '_') + '_' + key;
    }

    const hasAnyError = section?.fields?.some((field) => !!errors[field.key]);

    const sectionContent = (
        <div className={styles['inputs']}>
            {section?.sections?.map((section) => {
                return <Section key={generateKey(section.key)} section={section} dynamicFormId={dynamicFormId} />;
            })}

            {section?.fields?.map((field) => {
                return <Field key={generateKey(field.key)} field={field} />;
            })}
        </div>
    );

    return (
        <section className={styles['section']}>
            <div
                className={`${styles['section-header']}${section.collapsible && hasAnyError ? ` ${styles['error-text']}` : ''}`}
                onClick={section.collapsible ? toggleCollapsed : undefined}
            >
                <p>{section.title}</p>
                {section.collapsible &&
                    (collapsed ? <ExpandMoreIcon className={styles['expand-icon']} /> : <ExpandLessIcon className={styles['expand-icon']} />)}
            </div>

            {section.collapsible ? <Collapse in={!collapsed}>{sectionContent}</Collapse> : sectionContent}
        </section>
    );
}

Section.propTypes = {
    section: sectionType,
    dynamicFormId: PropTypes.number,
};
